/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavingsPlanBase {
    getFixupPrototypeFunction() { return SavingsPlanBase.fixupPrototype; }

    static newInstance(model: Partial<SavingsPlanBase>): SavingsPlanBase {
        let obj = Object.assign(new SavingsPlanBase(), model);
        SavingsPlanBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavingsPlanBase>): SavingsPlanBase {
        if (!model) return null;
        return SavingsPlanBase.newInstance(<SavingsPlanBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavingsPlanBase) {
        if (!obj) return;

        models.SavingsPlanBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavingsPlanBase): boolean {
        Object.setPrototypeOf(obj, SavingsPlanBase.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.utilization_percentage === undefined) {
            this.utilization_percentage = 0;
        }
    }

    /**
     * Savings plan ID
     */
    plan_id: string;

    /**
     * Savings plan name
     */
    plan_name: string;

    /**
     * Type of savings plan
     */
    plan_type: string;

    /**
     * Associated service account ID
     */
    service_account_id: string;

    /**
     * Overall utilization percentage
     */
    utilization_percentage: number;

}
